import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { ISupplierAdminChargebee } from './chargebee.types';

@Timestampable
@Untrackable
export class AdminChargebee extends AbstractDocument<ISupplierAdminChargebee> {
  readonly collections = {};
}
